import React from 'react';
import { useTranslation } from 'react-i18next';
import {useSelector} from 'react-redux';
import Signal from './Signal';
import {selectDeviceState, selectDeviceStateLoading} from "./deviceStateSlice";
import classes from './Signal.module.css';
import Spinner from "../ui/Spinner";
import {formatTimestamp, isEmpty} from "../../util/utils";

const MAIN_STREET_SIGNAL_DIRECTIONS = ['A', 'B'];
export const isMainStreetSignal = signal => MAIN_STREET_SIGNAL_DIRECTIONS.includes(signal.name);
export const isPedestrianSignal = signal => signal.name.indexOf('_') === 0;
export const isTrolleyPedestrianSignal = signal => signal.name.indexOf('VAROVA') === 0;
export const isPrioritySignal = signal => signal.name.includes('PRIO'); // RV1PRIO, PRIO_RV1
export const isTrolleySignal = signal => (signal.name.indexOf('RV') === 0 && !isPrioritySignal(signal));
export const isDriverSignal = signal => !isPedestrianSignal(signal) && !isTrolleyPedestrianSignal(signal) && !isTrolleySignal(signal) && !isPrioritySignal(signal);
const rowBreak = (key) => (<div key={`break${key}`} className={classes.break}/>);

export const SignalGroup = (props) => {
    const {intersection} = props;
    const deviceState = useSelector(selectDeviceState);
    const deviceStateLoading = useSelector(selectDeviceStateLoading);
    const { t } = useTranslation();

    const streetMain = intersection['paikka'];
    const mainStreetTitle = streetMain ?? t('signal.main_street');
    const crossStreetTitle = t('signal.side_street');
    const spinner = deviceStateLoading ? <Spinner/> : null;
    const signalGroup = deviceState?.['signalGroup'] ?? [];
    const timestamp = !isEmpty(signalGroup) ? formatTimestamp(deviceState.timestamp) : null;
    const mainStreetSignals = signalGroup
        .filter(isMainStreetSignal)
        .map(signal => <Signal signal={signal} key={signal['idx']}/>);
    const sideStreetSignals = signalGroup
        .filter(isDriverSignal)
        .filter(signal => !isMainStreetSignal(signal))
        .map(signal => <Signal signal={signal} key={signal['idx']}/>);
    const pedestrianSignals = signalGroup
        .filter(signal => (isPedestrianSignal(signal) || isTrolleyPedestrianSignal(signal)))
        .map(signal => <Signal signal={signal} key={signal['idx']}/>);
    const trolleySignals = signalGroup
        .filter(isTrolleySignal)
        .map(signal => <Signal signal={signal} key={signal['idx']}/>);
    const prioritySignals = signalGroup
        .filter(isPrioritySignal)
        .map(signal => <Signal signal={signal} key={signal['idx']}/>);

    return (
        <div className={classes.SignalGroup}>
            <div className={classes.SignalTitle} style={{marginBottom: '5px'}}>
                {timestamp || '\u00A0'} {spinner}
            </div>
            {!isEmpty(mainStreetSignals) ?
                [<div key={'title'} className={classes.SignalTitle}>{mainStreetTitle}</div>, rowBreak(1), mainStreetSignals, rowBreak(2)] : null}
            {!isEmpty(sideStreetSignals) ?
                [<div key={'title'} className={classes.SignalTitle}>{crossStreetTitle}</div>, rowBreak(1), sideStreetSignals, rowBreak(2)] : null}
            {!isEmpty(pedestrianSignals) ?
                [<div key={'title'} className={classes.SignalTitle}>{t('signal.pedestrian')}</div>, rowBreak(1), pedestrianSignals, rowBreak(2)] : null}
            {!isEmpty(trolleySignals) ?
                [<div key={'title'} className={classes.SignalTitle}>{t('signal.tram')}</div>, rowBreak(1), trolleySignals, rowBreak(2)] : null}
            {!isEmpty(prioritySignals) ?
                [<div key={'title'} className={classes.SignalTitle}>{t('signal.priority')}</div>, rowBreak(1), prioritySignals, rowBreak(2)] : null}
        </div>
    );
};
